import React from "react";
import { styled } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import SaveIcon from "@mui/icons-material/Save";
const componentStyles = theme => ({
  wrapper: {
    margin: theme.spacing(1),
    position: "relative"
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1
  }
});
const StyledRoot = styled("div")(({
  theme
}) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce((acc, [className, style]) => ({
    ...acc,
    [`& .${className}, &.${className}`]: style
  }), {})
}));
export const SaveLoader = () => {
  return <StyledRoot>
    <div className={"wrapper"}>
      <Fab aria-label="save" color="primary">
        <SaveIcon />
      </Fab>
      <CircularProgress size={68} className={"fabProgress"} />
    </div>
  
    </StyledRoot>;
};
